(function () {
  'use strict';

  angular.module('app').component('creditNoteList', creditNoteList());

  function creditNoteList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        onShowItem: '&',
      },
      controller: CreditNoteListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/credit-notes/credit-note-list/credit-note-list.component.html',
    };
  }

  CreditNoteListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'SessionService',
    'moment',
    'CreditNoteService',
    'DocumentService',
  ];

  function CreditNoteListComponent(
    config,
    UtilService,
    AbilityService,
    SessionService,
    moment,
    CreditNoteService,
    DocumentService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_creditnote_accountadmin'),
      canUpdate: AbilityService.can('update_creditnote_accountadmin'),
      canDestroy: AbilityService.can('destroy_creditnote_accountadmin'),
    };

    vm.creditNoteStatuses = [...config.CREDIT_NOTES_STATUSES];
    vm.creditNoteStatuses.unshift({
      label: 'ALL',
      value: null,
    });

    vm.atvCrStatuses = [...config.ATV_CR_STATUSES];
    vm.atvCrStatuses.unshift({
      label: 'ALL',
      value: null,
    });

    vm.statusDraft = 'draft';
    vm.statusProcessed = 'processed';
    vm.statusAccepted = 'accepted';
    vm.statusSent = 'sent';

    const apiUrl = 'credit_note_reports';
    vm.urlXls = apiUrl + '/export_credit_note_xls.xlsx';
    vm.urlPdf = apiUrl + '/export_credit_note_pdf.pdf';
    vm.reportName = 'credit_notes_report';

    // private properties
    // -----------------------
    const company = SessionService.getSelectedAccountCompany();

    let userLanguageCode = SessionService.getUserLanguage().code;
    const dateDisplay = userLanguageCode !== 'es' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';

    // const dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.$onInit = function () {
      vm.atvCrEnabled = company.atv_cr_enabled;

      setCreditNotes(vm.items);

      setDefaultFilters();

      setDocumentDatePicker();
    };

    // public methods
    // -----------------------
    vm.fetchResult = function () {
      vm.loadingItems = true;
      CreditNoteService.getCreditNotes(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        setCreditNotes(vm.items);

        vm.totalItems = vm.meta.totalItems;
        vm.loadingItems = false;
      });
    };

    vm.refresh = function () {
      vm.fetchResult();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      vm.fetchResult();
    };

    vm.showItem = function (item, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowItem({ item: item, mode: mode });
    };

    vm.deleteItem = function (item) {
      if (!vm.permissions.canDestroy) return;

      CreditNoteService.deleteCreditNote(item, vm.fetchResult());
    };

    // Atv functions
    vm.resendDocumentToAtv = function (item) {
      if (!item.canResend) return;

      vm.loadingDocument = true;
      DocumentService.resendDocumentToAtv(item, 'credit_notes').then(function (data) {
        if (data) {
          item.atv_status = data.atv_status;
          validateItemActions(item);
        }

        vm.loadingDocument = false;
      });
    };

    vm.downloadCreditNotePdf = function (item) {
      CreditNoteService.downloadCreditNotePdf(item, userLanguageCode);
    };

    vm.notifyDocumentToClient = function (item) {
      if (!item.canNotify) return;

      const successCallBack = function (email) {
        item.client_email_receipt = email;

        vm.loadingDocument = true;
        DocumentService.notifyDocumentToClient(item, 'credit_notes', email).then(function () {
          vm.loadingDocument = false;
        });
      };

      DocumentService.openNotifyDocumentToClient(
        item.client.email,
        successCallBack,
        'SEND_CREDIT_NOTE_TO_CLIENT'
      );
    };

    vm.openRelatedTransactions = function (item) {
      CreditNoteService.openRelatedTransactions(item, item.client);
    };

    vm.clearDocumentDate = function () {
      vm.documentDatePicker = {
        startDate: '',
        endDate: '',
      };

      delete vm.filterCriteria.by_date_from;
      delete vm.filterCriteria.by_date_to;

      vm.UtilService.filterResult();
    };

    vm.clearSearch = function () {
      setDefaultFilters();
      vm.fetchResult();
    };

    // private methods
    // -----------------------
    function setCreditNotes(items) {
      vm.sum_accounting_total = 0;
      items.forEach((item) => {
        vm.sum_accounting_total += item.accounting_grand_total;
        vm.base_currency_symbol = item.base_currency_symbol;
        item.date = moment(item.date).format(dateDisplay);
        item.credit_note_number = item.credit_note_number || '-';
        item.client_name = item.client.name + ' ' + item.client.last_name;

        validateItemActions(item);
      });
    }

    function validateItemActions(item) {
      item.canEdit =
        vm.permissions.canUpdate &&
        (!vm.atvCrEnabled ||
          (vm.atvCrEnabled &&
            item.document_type.numbering_type === 'electronic' &&
            item.status === 'draft'));
      item.canDelete = vm.permissions.canDestroy && item.status === 'draft';

      item.canResend =
        (vm.permissions.canUpdate &&
          vm.atvCrEnabled &&
          item.document_type.numbering_type === 'electronic' &&
          item.atv_status === 'not_sent') ||
        item.atv_status === 'pending' ||
        item.atv_status === 'sent' ||
        item.atv_status === 'received' ||
        item.atv_status === 'processing';

      item.canDownload =
        vm.permissions.canUpdate &&
        (!vm.atvCrEnabled ||
          (vm.atvCrEnabled &&
            item.document_type.numbering_type === 'electronic' &&
            (item.atv_status === vm.statusAccepted || item.atv_status === vm.statusSent)));

      item.canNotify =
        vm.permissions.canUpdate &&
        (!vm.atvCrEnabled ||
          (vm.atvCrEnabled &&
            item.document_type.numbering_type === 'electronic' &&
            item.atv_status === vm.statusAccepted));

      // item.status === vm.statusPaid &&
    }

    function setDefaultFilters() {
      vm.documentDatePicker = {
        // startDate: '',
        // endDate: '',
        startDate: vm.UtilService.startOfMonth(),
        endDate: vm.UtilService.today(),
      };

      vm.filterCriteria = CreditNoteService.getFilterCriteria();

      vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
        vm.UtilService.startOfMonth()
      );
      vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());

      // vm.filterCriteria.by_status = vm.creditNoteStatuses[0].value;
      // vm.filterCriteria.by_atv_status = vm.atvCrStatuses[0].value;
    }

    function setDocumentDatePicker() {
      let filterByDocumentDate = () => {
        vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
          vm.documentDatePicker.startDate
        );

        vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.documentDatePicker.endDate);

        // vm.filterCriteria.by_date_to = moment(
        //   vm.UtilService.startOfDayFormat(vm.documentDatePicker.endDate)
        // ).add(1, 'days');

        vm.UtilService.filterResult();
      };

      vm.documentDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByDocumentDate,
        rangeOptions: config.DOCUMENT_DATE_OPTIONS,
        dateDisplay: dateDisplay,
      });
    }
  }
})();
